// @ts-nocheck
import { printOptionSelector } from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/OrderDetailsTotalSelectors";
import { useSelector } from "react-redux";

const usePrintOption = () => {
    return useSelector(printOptionSelector);
};
export default usePrintOption;
